import { Icon } from "./Icon.tsx";

/** A droplet infiltrating a layered filter medium, distinct from
 * AquiferIcon.tsx's wavy groundwater lines (solid filter media, not a
 * water table). */
export function LidControlIcon() {
  return (
    <Icon>
      <path d="M12 2.5c1.4 1.8 2.4 3.1 2.4 4.3a2.4 2.4 0 1 1-4.8 0c0-1.2 1-2.5 2.4-4.3Z" />
      <rect x="4" y="10" width="16" height="10" rx="1" />
      <path d="M4 14h16M4 17h16" />
    </Icon>
  );
}
